import React, { createContext, useContext } from 'react';

/**
 * Rules & Permissions for the campaign on screen. Provided by the position page from
 * campaign.allowed_actions; `<Button need="candidate.add">` reads it and renders disabled
 * (with the reason) when the action isn't allowed. Outside a provider everything is allowed —
 * the server still enforces every rule.
 */
const CampaignRulesContext = createContext(null);

export function CampaignRulesProvider({ campaign, children }) {
  const allowed = Array.isArray(campaign?.allowed_actions) ? campaign.allowed_actions : null;
  const value = {
    locked: !!campaign?.locked,
    can: (key) => !allowed || allowed.includes(key),
  };
  return <CampaignRulesContext.Provider value={value}>{children}</CampaignRulesContext.Provider>;
}

export function useCampaignRules() {
  return useContext(CampaignRulesContext);
}

export function deniedReason(rules) {
  return rules?.locked
    ? 'This position is locked. Only managers and admins can change it.'
    : 'Your Rules & Permissions don\'t allow this.';
}
